var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5557",
    "data-name": "Group 5557",
    transform: "translate(-1048 -120)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_57",
    "data-name": "Ellipse 57",
    cx: 10,
    cy: 10,
    r: 10,
    transform: "translate(1048 120)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5555",
    "data-name": "Group 5555"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_759",
    "data-name": "Line 759",
    y2: 7,
    transform: "translate(1058 124.5)",
    fill: "none",
    stroke: "#aa3b13",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_91",
    "data-name": "Ellipse 91",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(1056.5 133.5)",
    fill: "#aa3b13"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFail);
export default __webpack_public_path__ + "static/media/fail.0f4664355fd023997f2d9884f918467b.svg";
export { ForwardRef as ReactComponent };